import { Pipe, PipeTransform } from '@angular/core';
import { GetPhoneNumberDetail_phoneNumber_location } from 'src/app/pages/phone-number-details/queries/generated/GetPhoneNumberDetail';

@Pipe({
   name: 'ndtFullLocation',
   standalone: false,
})
export class FullLocationPipe implements PipeTransform {
   transform(location: GetPhoneNumberDetail_phoneNumber_location): string {
      return transformAddress(location);
   }
}

export function transformAddress(location: GetPhoneNumberDetail_phoneNumber_location): string {
   return `${location.houseNumber ?? ''} ${location.directionalPrefix ?? ''} ${location.streetName ?? ''} ${
      location.streetNameSuffix ?? ''
   } ${location.directionalPostfix ?? ''}
   ${location.city ?? ''}, ${location.state ?? ''}${location.postalCode ? ` ${location.postalCode}` : ''}`.replace(
      /  +/g,
      ' '
   );
}
